export default __webpack_public_path__ + "static/media/5.99ce862b.png";